import { useEffect, useState, useRef, useDeferredValue } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchServicesList, removeService } from 'modules/categories/categoriesSlice';
// eslint-disable-next-line max-len
import LabsServicesComponent from 'modules/categories/labs/components/LabsServicesComponent';
import { searchQueryMinLength, status } from 'constants/general';
import { useParams } from 'react-router-dom';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const LabsServicesContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const { priceListId } = useParams();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [searchQuery, setSearchQuery] = useState('');
  const InitialQueryString = {
    priceListId,
    pageNumber: 1,
    pageSize: 10,
  };
  const [servicesQueryString, setServicesQueryString] = useState(InitialQueryString);
  const [isCreateServiceModalHidden, setIsCreateServiceModalHidden] = useState(true);

  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  const removeServiceStatus = useSelector(state => state.categories.removeService.status);

  const prevRemoveService = useDeferredValue(removeServiceStatus);
  useEffect(() => {
    if (status.SUCCESS === removeServiceStatus && prevRemoveService !== removeServiceStatus) {
      setServicesQueryString({ ...InitialQueryString });
    }
  }, [removeServiceStatus]);

  useEffect(() => {
    dispatch(fetchServicesList(servicesQueryString));
  }, [dispatch, servicesQueryString]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleOnToggleAddProvidersModel = isHidden => {
    setIsCreateServiceModalHidden(isHidden);
    if (isHidden) setServicesQueryString({ ...InitialQueryString });
  };

  const handleInputFieldChange = () => {};

  const handleSearchInputChange = (searchTerm, reset) => {
    const queryString = {
      ...servicesQueryString,
      pageNumber: 1,
      isShowMore: false,
    };
    if (searchTerm) queryString.searchterm = searchTerm;
    if (reset) delete queryString.searchterm;

    setServicesQueryString(queryString);
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        handleSearchInputChange(value);
      }, 500);
    } else if (value.length < searchQueryMinLength && servicesQueryString.searchterm)
      handleSearchInputChange(value, true);
  };

  const handleShowMoreClick = () => {
    const data = {
      ...servicesQueryString,
    };
    data.pageNumber += 1;
    data.isShowMore = true;
    setServicesQueryString(data);
  };

  const handleRemoveService = rowDataPayload => {
    const { id, priceListId } = rowDataPayload;
    const payload = {
      id,
      data: {
        priceListId,
      },
    };
    dispatch(removeService(payload));
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <div>
      <LabsServicesComponent
        isCreateServiceModalHidden={isCreateServiceModalHidden}
        setIsCreateServiceModalHidden={handleOnToggleAddProvidersModel}
        handleInputFieldChange={handleInputFieldChange}
        searchQuery={searchQuery}
        handleSearchBarInputChange={handleSearchBarInputChange}
        servicesQueryString={servicesQueryString}
        handleShowMoreClick={handleShowMoreClick}
        handleRemoveService={handleRemoveService}
        priceListId={priceListId}
      />
    </div>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

LabsServicesContainer.propTypes = {};

LabsServicesContainer.defaultProps = {};

export default LabsServicesContainer;
